import clsx, { type ClassValue } from 'clsx';

/** Conditional className joiner. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
